import React, { useEffect, useState, createElement } from 'react';
// Create a global state to track when GSAP is loaded
if (typeof window !== 'undefined') {
  window.gsapLoaded = false;
  window.scrollTriggerLoaded = false;
}
export function ScriptLoader() {
  const [scriptsLoaded, setScriptsLoaded] = useState(false);
  useEffect(() => {
    // Check if scripts are already loaded
    if (window.gsap && window.ScrollTrigger) {
      window.gsapLoaded = true;
      window.scrollTriggerLoaded = true;
      setScriptsLoaded(true);
      return;
    }
    // Load GSAP
    const gsapScript = document.createElement('script');
    gsapScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js';
    gsapScript.async = true;
    // Load ScrollTrigger
    const scrollTriggerScript = document.createElement('script');
    scrollTriggerScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js';
    scrollTriggerScript.async = true;
    // Set up onload handlers
    gsapScript.onload = () => {
      window.gsapLoaded = true;
      if (window.scrollTriggerLoaded) {
        setScriptsLoaded(true);
      }
    };
    scrollTriggerScript.onload = () => {
      window.scrollTriggerLoaded = true;
      if (window.gsapLoaded) {
        setScriptsLoaded(true);
      }
    };
    // Append scripts to document head
    document.head.appendChild(gsapScript);
    document.head.appendChild(scrollTriggerScript);
    return () => {
      // Clean up
      if (document.head.contains(gsapScript)) {
        document.head.removeChild(gsapScript);
      }
      if (document.head.contains(scrollTriggerScript)) {
        document.head.removeChild(scrollTriggerScript);
      }
    };
  }, []);
  // Log when scripts are loaded
  useEffect(() => {
    if (scriptsLoaded) {
      console.log('GSAP and ScrollTrigger loaded successfully');
    }
  }, [scriptsLoaded]);
  return null;
}